import { useCallback } from 'react'

/**
 * Hook to create a usable onClick handler that
 * prevents default behavior unless metaKey is held.
 *
 * Accepts a defaultAction function, returns a handler expecting an event.
 */
export function useUsableOnClick() {
  return useCallback((defaultAction) => (event) => {
    if (!event || typeof event.stopPropagation !== 'function') {
      // If invalid event, just run the action
      defaultAction()
      return
    }

    if (event.metaKey) {
      return
    }

    event.stopPropagation()
    event.preventDefault()
    defaultAction()
  }, [])
}
